import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from './CookieConsent';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Skip link pour navigation au clavier */}
      <a href="#main-content" className="skip-link">
        Aller au contenu principal
      </a>
      
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main id="main-content" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 min-h-[calc(100vh-500px)] pt-20" role="main">
        {children}
      </main>

      {/* Footer */}
      <Footer />

      {/* Popup d'acceptation des cookies */}
      <CookieConsent />
    </div>
  );
};

export default PublicLayout;
